import { VNodeChildren } from 'vue';
import { namedLink } from '@/ui/components';

export const inspectionDetailPageLink = (anchor: VNodeChildren, id: number) => namedLink(
  anchor,
  'inspectionDetail',
  id.toString(),
);

export const getScore = (value: number | undefined | null) => {
  if (value === undefined || value === null) {
    return '';
  }

  const decimalPart = value.toString().split('.')[1];
  if (decimalPart && decimalPart.length > 2) {
    return (Math.round(value * 100) / 100).toString();
  }

  return value.toString();
};
